// extracted by mini-css-extract-plugin
export default {"indented":"search_highlight_plain_row-module___indented___a3a3f0d5","values":"search_highlight_plain_row-module___values___d3d6e6bb"};